var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _g5, _path9, _g6, _path0, _path1, _g7, _path10, _path11, _g8, _path12, _path13, _path14, _path15, _g9, _path16, _g0, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 32,
    viewBox: "0 0 19 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4756 7.58394C17.4756 7.58394 10.7231 7.12925 10.6771 14.2643C17.9374 14.2191 17.4756 7.58394 17.4756 7.58394Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 7,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8926 7.00781H10.1349V14.7128H17.8926V7.00781Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2823 14.6555L10.6793 14.6534C13.0211 14.638 14.8424 13.96 16.0932 12.6351C18.0514 10.5623 17.8748 7.68189 17.8665 7.5605L17.8435 7.22617L17.5018 7.20251C17.5018 7.20251 17.4057 7.19531 17.2364 7.19531C16.0828 7.19531 10.3282 7.53684 10.2844 14.2645L10.2823 14.6555Z",
    fill: "url(#paint0_linear_16595_30411)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 7,
    height: 11
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2764 0.0078125L6.65873 0.0078125V10.7053H12.2764V0.0078125Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.43541 10.5697L9.71441 10.2919C11.3602 8.65421 12.1596 6.90851 12.0906 5.10313C11.983 2.27626 9.78651 0.362881 9.69246 0.283671L9.43541 0.0625L9.17731 0.283671C9.08326 0.362881 6.88678 2.27626 6.77915 5.10313C6.71019 6.90851 7.50957 8.65421 9.15536 10.2919L9.43541 10.5697Z",
    fill: "url(#paint1_linear_16595_30411)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2006 7.58394C1.2006 7.58394 7.952 7.12925 7.99902 14.2643C0.737688 14.2191 1.2006 7.58394 1.2006 7.58394Z",
    fill: "#71B261"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 7,
    width: 9,
    height: 8
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53027 7.00781H0.772586V14.7128H8.53027V7.00781Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39355 14.6555L8.39042 14.2645C8.34653 7.53684 2.59201 7.19531 1.43943 7.19531C1.26911 7.19531 1.17297 7.20251 1.17297 7.20251L0.83232 7.22617L0.808287 7.5605C0.799927 7.68189 0.623331 10.5612 2.58156 12.6351C3.83132 13.96 5.6537 14.638 7.99647 14.6534L8.39355 14.6555Z",
    fill: "url(#paint2_linear_16595_30411)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 19,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4297 11.3906H0.239253V31.9996H18.4297V11.3906Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_16595_30411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 19,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0713 31.9951V11.4026C6.13295 11.3984 6.19356 11.3984 6.25521 11.3984H12.4079V31.9951H6.0713ZM13.9847 31.9951H12.4079V11.4026H12.4423C14.992 11.4026 17.2303 13.4507 17.4142 15.9515L18.2763 27.4513C18.4654 29.9469 16.5333 31.9951 13.9847 31.9951ZM4.71391 31.9951C2.16424 31.9951 0.233183 29.9469 0.421274 27.4462L1.2844 15.9474C1.46831 13.5073 3.60523 11.4982 6.07548 11.4026V31.9951H4.71391Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.40778 31.9996H18.2764V11.3906H0.40778V31.9996Z",
    fill: "url(#paint3_linear_16595_30411)"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 21,
    width: 7,
    height: 6
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1943 21.3438H6.4325V26.376H12.1943V21.3438Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.31362 27.694C9.50276 27.694 9.6898 27.6738 9.87476 27.6328C10.0608 27.5926 10.2405 27.5323 10.415 27.4527C10.5895 27.3723 10.7556 27.275 10.9124 27.1592C11.0702 27.0434 11.2154 26.9115 11.3492 26.7644C11.4829 26.6164 11.6021 26.4564 11.7066 26.2827C11.8121 26.1098 11.9009 25.9265 11.973 25.7335C12.0451 25.5413 12.0995 25.3427 12.1371 25.1384C12.1736 24.9334 12.1914 24.7275 12.1914 24.5184C12.1914 24.3102 12.1736 24.1035 12.1371 23.8993C12.0995 23.695 12.0451 23.4964 11.973 23.3034C11.9009 23.1112 11.8121 22.9279 11.7066 22.755C11.6021 22.5813 11.4829 22.4213 11.3492 22.2733C11.2154 22.1262 11.0702 21.9943 10.9124 21.8785C10.7556 21.7627 10.5895 21.6654 10.415 21.585C10.2405 21.5054 10.0608 21.4451 9.87476 21.4049C9.6898 21.3639 9.50276 21.3438 9.31362 21.3438C9.12449 21.3438 8.93744 21.3639 8.75249 21.4049C8.56649 21.4451 8.38675 21.5054 8.21225 21.585C8.03774 21.6654 7.8716 21.7627 7.71485 21.8785C7.55707 21.9943 7.41182 22.1262 7.27807 22.2733C7.14431 22.4213 7.02519 22.5813 6.92069 22.755C6.81515 22.9279 6.72633 23.1112 6.65423 23.3034C6.58213 23.4964 6.52779 23.695 6.49018 23.8993C6.4536 24.1035 6.43584 24.3102 6.43584 24.5184C6.43584 24.7275 6.4536 24.9334 6.49018 25.1384C6.52779 25.3427 6.58213 25.5413 6.65423 25.7335C6.72633 25.9265 6.81515 26.1098 6.92069 26.2827C7.02519 26.4564 7.14431 26.6164 7.27807 26.7644C7.41182 26.9115 7.55707 27.0434 7.71485 27.1592C7.8716 27.275 8.03774 27.3723 8.21225 27.4527C8.38675 27.5323 8.56649 27.5926 8.75249 27.6328C8.93744 27.6738 9.12449 27.694 9.31362 27.694Z",
    fill: "#3D1F1E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 24,
    width: 6,
    height: 4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8652 24.2344H6.88293V27.7597H11.8652V24.2344Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.84387 25.9959C6.84387 26.0825 6.86059 26.1683 6.89193 26.2541C6.92433 26.3391 6.97135 26.4218 7.03405 26.5022C7.09674 26.5826 7.17302 26.6583 7.26393 26.731C7.35485 26.8029 7.45829 26.8701 7.57428 26.9312C7.68923 26.993 7.81567 27.0479 7.95151 27.0958C8.08735 27.1445 8.23051 27.1847 8.38203 27.2179C8.53355 27.2512 8.68924 27.2767 8.84912 27.2937C9.01004 27.3107 9.17201 27.3192 9.33502 27.3192C9.49908 27.3192 9.66104 27.3107 9.82092 27.2937C9.98184 27.2767 10.1375 27.2512 10.2891 27.2179C10.4395 27.1847 10.5837 27.1445 10.7196 27.0958C10.8554 27.0479 10.9819 26.993 11.0968 26.9312C11.2128 26.8701 11.3162 26.8029 11.4071 26.731C11.4981 26.6583 11.5743 26.5826 11.637 26.5022C11.6997 26.4218 11.7468 26.3391 11.7791 26.2541C11.8105 26.1683 11.8262 26.0825 11.8262 25.9959C11.8262 25.9086 11.8105 25.8228 11.7791 25.737C11.7468 25.652 11.6997 25.5693 11.637 25.4889C11.5743 25.4085 11.4981 25.3327 11.4071 25.2601C11.3162 25.1882 11.2128 25.121 11.0968 25.0599C10.9819 24.9981 10.8554 24.9432 10.7196 24.8953C10.5837 24.8466 10.4395 24.8064 10.2891 24.7731C10.1375 24.7399 9.98184 24.7144 9.82092 24.6974C9.66104 24.6804 9.49908 24.6719 9.33502 24.6719C9.17201 24.6719 9.01004 24.6804 8.84912 24.6974C8.68924 24.7144 8.53355 24.7399 8.38203 24.7731C8.23051 24.8064 8.08735 24.8466 7.95151 24.8953C7.81567 24.9432 7.68923 24.9981 7.57428 25.0599C7.45829 25.121 7.35485 25.1882 7.26393 25.2601C7.17302 25.3327 7.09674 25.4085 7.03405 25.4889C6.97135 25.5693 6.92433 25.652 6.89193 25.737C6.86059 25.8228 6.84387 25.9086 6.84387 25.9959Z",
    fill: "#FA5B5B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 9,
    height: 9
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14453 10.8828H0.000215586V18.9005H8.14453V10.8828Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_16595_30411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 10,
    width: 10,
    height: 9
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.07042 10.875C6.32019 10.875 8.14258 12.6691 8.14258 14.8838C8.14258 17.0976 6.32019 18.8927 4.07042 18.8927C1.8217 18.8927 -0.00173482 17.0976 -0.00173482 14.8838C-0.00173482 12.6691 1.8217 10.875 4.07042 10.875Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14258 10.875H-0.00173482V18.8927H8.14258V10.875Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 11,
    width: 6,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 11.875H2.04551V16.8755H7.125V11.875Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_16595_30411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 11,
    width: 6,
    height: 6
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58571 11.8672C5.98907 11.8672 7.12598 12.9864 7.12598 14.368C7.12598 15.7485 5.98907 16.8677 4.58571 16.8677C3.18339 16.8677 2.04649 15.7485 2.04649 14.368C2.04649 12.9864 3.18339 11.8672 4.58571 11.8672Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12598 11.8672H2.04649V16.8677H7.12598V11.8672Z",
    fill: "#3D1F1E"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68861 15.2828C4.68861 14.6811 4.23294 14.2473 3.63503 14.2473C4.20515 14.2473 4.68812 13.7853 4.68812 13.2114C4.68812 13.7798 5.13885 14.2473 5.74219 14.2473C5.13885 14.2473 4.68861 14.7029 4.68861 15.2828Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68861 13.2109L4.68812 13.2114M4.68812 13.2114C4.68812 13.7853 4.20515 14.2473 3.63503 14.2473C4.23294 14.2473 4.68861 14.6811 4.68861 15.2828C4.68861 14.7029 5.13885 14.2473 5.74219 14.2473C5.13885 14.2473 4.68812 13.7798 4.68812 13.2114Z",
    stroke: "white",
    strokeWidth: 0.622067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 9,
    height: 9
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3691 11.0078H10.2248V19.0255H18.3691V11.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_16595_30411)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 11,
    width: 9,
    height: 9
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.296 11C16.5458 11 18.3682 12.7941 18.3682 15.0088C18.3682 17.2226 16.5458 19.0177 14.296 19.0177C12.0473 19.0177 10.2239 17.2226 10.2239 15.0088C10.2239 12.7941 12.0473 11 14.296 11Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3682 11H10.2239V19.0177H18.3682V11Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_16595_30411",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 6,
    height: 6
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8093 12.0156C16.2127 12.0156 17.3496 13.1349 17.3496 14.5164C17.3496 15.8969 16.2127 17.0161 14.8093 17.0161C13.407 17.0161 12.2701 15.8969 12.2701 14.5164C12.2701 13.1349 13.407 12.0156 14.8093 12.0156Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_16595_30411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3496 12.0156H12.2701V17.0161H17.3496V12.0156Z",
    fill: "#3D1F1E"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9122 15.4156C14.9122 14.8139 14.4566 14.3802 13.8587 14.3802C14.4288 14.3802 14.9118 13.9181 14.9118 13.3442C14.9118 13.9127 15.3625 14.3802 15.9658 14.3802C15.3625 14.3802 14.9122 14.8357 14.9122 15.4156Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9122 13.3438L14.9118 13.3442M14.9118 13.3442C14.9118 13.9181 14.4288 14.3802 13.8587 14.3802C14.4566 14.3802 14.9122 14.8139 14.9122 15.4156C14.9122 14.8357 15.3625 14.3802 15.9658 14.3802C15.3625 14.3802 14.9118 13.9127 14.9118 13.3442Z",
    stroke: "white",
    strokeWidth: 0.622067,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16595_30411",
    x1: 14.0781,
    y1: 7.19531,
    x2: 14.0781,
    y2: 14.6555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16595_30411",
    x1: 9.43489,
    y1: 0.0625,
    x2: 9.43489,
    y2: 10.5697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16595_30411",
    x1: 4.59715,
    y1: 7.19531,
    x2: 4.59715,
    y2: 14.6555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C4EEB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#45AB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16595_30411",
    x1: 9.34207,
    y1: 11.3906,
    x2: 9.34207,
    y2: 31.9996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    stopColor: "#FFDE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F19F10"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini-logo.b349180637f44ee96d89a99acd33befd.svg";
export { ForwardRef as ReactComponent };